"use strict";
/* eslint-disable react/button-has-type */
// ^ this is fun – https://github.com/yannickcr/eslint-plugin-react/issues/1555
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.BUTTON_SIZES = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Button_styles_1 = __importStar(require("./Button.styles"));
exports.BUTTON_SIZES = Button_styles_1.heights;
function Button(_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 'md' : _b, color = _a.color, _c = _a.type, type = _c === void 0 ? 'button' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, children = _a.children, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, _e = _a.fullWidth, fullWidth = _e === void 0 ? false : _e, _f = _a.variant, variant = _f === void 0 ? 'filled' : _f, _g = _a.radius, radius = _g === void 0 ? 'sm' : _g, _h = _a.component, Element = _h === void 0 ? 'button' : _h, elementRef = _a.elementRef, themeOverride = _a.themeOverride, others = __rest(_a, ["className", "size", "color", "type", "disabled", "children", "leftIcon", "rightIcon", "fullWidth", "variant", "radius", "component", "elementRef", "themeOverride"]);
    var classes = Button_styles_1.default({
        radius: radius,
        color: color,
        size: size,
        fullWidth: fullWidth,
        theme: theme_1.useMantineTheme(themeOverride),
    });
    return (react_1.default.createElement(Element, __assign({}, others, { className: clsx_1.default(classes.shared, classes[variant], className), type: type, disabled: disabled, "data-mantine-composable": true, ref: elementRef, onTouchStart: function () { } }),
        react_1.default.createElement("div", { className: classes.inner },
            leftIcon && (react_1.default.createElement("span", { "data-mantine-left-icon": true, className: clsx_1.default(classes.icon, classes.leftIcon) }, leftIcon)),
            react_1.default.createElement("span", { className: classes.label, "data-mantine-label": true }, children),
            rightIcon && (react_1.default.createElement("span", { "data-mantine-right-icon": true, className: clsx_1.default(classes.icon, classes.rightIcon) }, rightIcon)))));
}
exports.Button = Button;
Button.displayName = '@mantine/core/Button';
